import BossModel from "@/models/BossModel";

export default class Role extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'user/role';

    /**
     *
     * @type {string}
     */
    static entity = 'roles';

    static fields() {
		return {
			id: this.attr(null),
			name: this.attr(null),
			updated_at: this.attr(null),
			permissions: this.attr(null),
			created_at: this.attr(null),
		}
	}

    /**
     *
     * @param format
     * @returns {*}
     */
    static fetchPermissions(format=null) {
        return this.api().action('permissions').where('format', format).get();
    }
}
